export type IKYCDetailsInitialValueProps = {
	document: string | null;
	document_number: string | null;
	IMR_Code: string | null;
	document_url: string;
	profile_url: string;
	document_image: string | null;
	kyc_file_name?: string;
	bde_code?: string;
	secondary_club?: string | null;
	role?: string;
};

export const defaultKYCDetailFormInitialValues: IKYCDetailsInitialValueProps = {
	document: '',
	document_number: '',
	document_url: '',
	profile_url: '',
	IMR_Code: '',
	document_image: null,
	kyc_file_name: '',
	bde_code: '',
	secondary_club: '',
	role: '',
};

export type TDocumentImage = {
	url?: string;
	imageName?: string;
};

export type TClubDetails = {
	id: number;
	value: string;
};
export type TIMRCodeDetails = {
	id: number;
	value: string;
};

export type SecondaryClub = {
	id: number;
	sfid: string;
	name: string;
	clubname: string | null;
	clubid: string;
	assigned_cmdi: string;
	kaeclub_c: string;
};
